import { render, staticRenderFns } from "./DentistMCD.vue?vue&type=template&id=3822ba38&scoped=true"
import script from "./DentistMCD.vue?vue&type=script&lang=js"
export * from "./DentistMCD.vue?vue&type=script&lang=js"
import style0 from "./DentistMCD.vue?vue&type=style&index=0&id=3822ba38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822ba38",
  null
  
)

export default component.exports